// 🔧 volunteer_builder.js
// ✅ Purpose: Orchestrates the Volunteer Engine build process for Core Demo Events
// ✅ Features:
// - Runs as part of the Core Demo Package, not as an optional add-on
// - Coordinates volunteer activity and time slot generation
// - Seeds volunteer demo data through the repository layer
// - Updates DemoContext with created volunteer data
// - Returns standardized execution results for Demo Report v2
// - Fully block-commented for clarity and future devs

import { generateVolunteers } from "./volunteer_generator";
import { seedVolunteers } from "./volunteer_seeder";
import { buildVolunteerReport } from "./volunteer_report";

export const buildVolunteers = async ({
  demoContext,
} = {}) => {
  console.log("🙋 Volunteer Builder started.");

  // =====================================================
  // Generate volunteer demo content.
  // =====================================================
  const volunteerPlan = generateVolunteers({
    demoContext,
  });

  // =====================================================
  // Persist volunteer activities and time slots.
  // =====================================================
  const volunteerResults = await seedVolunteers({
    demoContext,
    volunteerPlan,
  });

  // =====================================================
  // Store Volunteer Engine results on shared DemoContext.
  // =====================================================
  demoContext.volunteers = {
    activities: volunteerResults.activities || [],
    timeSlots: volunteerResults.timeSlots || [],
  };

  // =====================================================
  // Return standardized Demo Report output.
  // =====================================================
  return buildVolunteerReport({
    volunteerResults,
  });
};